<template>
  <modal :center="false" :show="visible" modalClasses="modal-lg">
    <h3 class="text-center">
      {{ info.id ? "Cập nhật nhân viên" : "Thêm mới nhân viên" }}
    </h3>
    <block ref="bmdal">
      <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <b-row>
            <b-col sm="6" xs="12">
              <ValidationProvider
                name="Họ tên"
                rules="required"
                v-slot="{ errors }"
              >
                <base-input
                  label="Họ tên"
                  :error="errors[0]"
                  v-model="info.name"
                  :valid="errors.length == 0"
                ></base-input>
              </ValidationProvider>
            </b-col>
            <b-col sm="6" xs="12">
              <ValidationProvider
                name="Tên đăng nhập"
                vid="username"
                rules="required|onlyletter"
                v-slot="{ errors }"
              >
                <base-input
                  label="Tên đăng nhập"
                  placeholder="Tên đăng nhập (viết liền không dấu)"
                  v-model="info.username"
                  :error="errors[0]"
                  :valid="errors.length == 0 && info.username.length > 0"
                ></base-input>
              </ValidationProvider>
            </b-col>
            <b-col sm="6" xs="12">
              <base-input
                label="Số điện thoại"
                v-model="info.phone"
              ></base-input>
            </b-col>
            <b-col sm="6" xs="12">
              <ValidationProvider
                name="Email"
                vid="email"
                :rules="{ required: true, email: true }"
                v-slot="{ errors }"
              >
                <base-input
                  placeholder="Email"
                  label="Email"
                  v-model="info.email"
                  :error="errors[0]"
                  :valid="errors.length == 0 && info.email.length > 0"
                ></base-input>
              </ValidationProvider>
              <!-- <base-input
                placeholder="Email"
                label="Email"
                v-model="info.email"
              ></base-input> -->
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <base-upload
                :preview="uploadPreview"
                @doUpload="doUpload"
              ></base-upload>
            </b-col>
          </b-row>
        </form>
        <hr />
        <b-row>
          <b-col sm="6" xs="12" md="4">
            <b-button class="mb-2" block variant="success" @click="doSave(1)">
              Lưu tiếp (Shift + F4)
            </b-button>
          </b-col>
          <b-col sm="6" xs="12" md="4">
            <b-button
              class="mb-2"
              type="submit"
              block
              variant="dark"
              @click="doSave(0)"
            >
              Lưu đóng (F4)
            </b-button>
          </b-col>
          <b-col sm="12" md="4">
            <b-button
              class="mb-2"
              block
              variant="secondary"
              @click="handleClose"
            >
              Đóng (Esc)
            </b-button>
          </b-col>
        </b-row>
      </ValidationObserver>
    </block>
    <event
      @doCancel="handleClose"
      @doSave="doSave(0)"
      @doSaveContinue="doSave(1)"
    ></event>
  </modal>
</template>
<script>
import { userService, uploadService } from "@/_services";
export default {
  props: {},
  data() {
    return {
      visible: false,
      info: {
        name: "",
        avatar: "",
        phone: "",
        username: "",
        email: "",
        role: {},
        roleId: 0,
        isNewRecord: true
      },
      ownInfo: {},
      uploadPreview: "/img/placeholder/default.jpg"
    };
  },
  methods: {
    doSave: function(type) {
      var self = this;
      if (!this.visible) return;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$refs.bmdal.block();
        if (self.info.id) {
          userService
            .update(self.info.id, self.info)
            .then(res => {
              self.ownInfo.name = self.info.name;
              self.ownInfo.username = self.info.username;
              self.ownInfo.name = self.info.name;
              self.ownInfo.avatar = self.info.avatar;
              self.ownInfo.phone = self.info.phone;
              self.ownInfo.email = self.info.email;
              if (type == 0) {
                self.visible = false;
              }
              this.$alertify.success(res.message, {
                duration: 4000
              });
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.$refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              this.$refs.bmdal.unBlock();
            });
        } else {
          userService
            .create(self.info)
            .then(res => {
              self.$emit("submit:success");
              if (type == 0) {
                self.visible = false;
              }
              self.info = { username: "", email: "" };
              this.$alertify.success(res.message, {
                duration: 4000
              });
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.$refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              this.$refs.bmdal.unBlock();
            });
        }
      });
    },
    setData(info) {
      this.ownInfo = info;
      this.info = Object.assign({}, info);
      if (this.info.avatar) {
        this.uploadPreview = this.$mediaURI + this.info.avatar;
      } else {
        this.uploadPreview = "/img/placeholder/default.jpg";
      }
      delete this.info.rule;
    },
    handleClose() {
      this.visible = false;
    },
    doUpload(data, cb) {
      var self = this;
      this.uploadPreview = data.preview;
      uploadService.avatar({ file: data.file }).then(res => {
        self.info.avatar = res.data.path;
        cb();
      });
      console.log(data);
    }
  }
};
</script>
<style lang="scss">
.wrap-drop-img {
  height: 200px;
}
</style>
